import { useTranslations } from '@vocab/react';
import { Box, Button, Stack, Text, IconStatistics } from 'braid-design-system';

import type { Poll } from 'src/mapper/threadMapper';

import translations from './.vocab';

import * as styles from './PollDialog.css';

interface PollDialogProps {
  poll: Poll;
  voted?: boolean;
  onClick?: (optionId: string) => void;
}

// TODO: Create a proper poll dialog
export default ({ poll, onClick, voted = false }: PollDialogProps) => {
  const { t } = useTranslations(translations);

  const { options, voteCountLabel, endDate, ended } = poll;

  return (
    <Box paddingTop="none" className={styles.pollContainer}>
      <Stack space={{ mobile: 'xsmall', desktop: 'xxsmall' }}>
        {voted || ended
          ? // Results display
            options.map((option, index) => (
              <Box
                key={index}
                className={styles.pollBarContainer}
                style={{ maxWidth: '540px' }}
              >
                <Box
                  className={`
                    ${option.voted ? styles.border : ''}`}
                >
                  <Box
                    className={`${styles.pollFill} 
                    ${option.voted ? styles.mostVoted : ''}`}
                    style={{
                      width: `${option.percentage}%`,
                      minWidth: option.percentage === 0 ? '5px' : 'auto',
                      maxWidth: '100%',
                    }}
                  >
                    <Text weight="strong" size="small">
                      {option.title}
                    </Text>
                  </Box>
                </Box>
                <Box style={{ textAlign: 'right' }}>
                  <Text weight="strong" size="small">
                    {option.percentage}%
                  </Text>
                </Box>
              </Box>
            ))
          : // Poll dispaly
            options.map((option) => (
              <Box
                display="flex"
                flexDirection="row"
                justifyContent="spaceBetween"
                key={option.id}
                style={{ maxWidth: '540px' }}
              >
                <Button
                  size="small"
                  tone="formAccent"
                  variant="ghost"
                  onClick={onClick ? () => onClick(option.id) : undefined}
                >
                  {option.title}
                </Button>
              </Box>
            ))}
      </Stack>
      <Box paddingTop="small">
        <Text size="small" tone="secondary" icon={<IconStatistics />}>
          {voteCountLabel} {t('votes')} &#183; {endDate}
        </Text>
      </Box>
    </Box>
  );
};
